import { addQueryArgs } from "@wordpress/url";

export default () => ({
  url: `wp-json/wp_query/args/`,
  posts: [],
  offset: 0,
  lastPost: false,
  fetchData(siteurl, obj) {
    obj.offset = this.offset;
    const url = addQueryArgs(siteurl + this.url, obj);
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.posts = this.posts.concat(data);
        this.lastPost = data.length < obj.posts_per_page && true;
      })
      .then(() => (this.offset += Number(obj.posts_per_page)));
  },
});
